import * as _ from "./lodash";
export default function evalPredicate(predicate) {
  if (predicate === void 0) {
    predicate = false;
  }

  return _.isFunction(predicate) ? predicate() : !!predicate;
}
//# sourceMappingURL=eval-predicate.js.map